import { MessageFormatElement } from 'react-intl';
import { FetchAttr } from 'src/api/types';
import { isClientSide } from './constants';

export type Locale =
  | Record<string, string>
  | Record<string, MessageFormatElement[]>;

// Locales utilized by the client
export enum Locales {
  RU = 'ru',
  UA = 'default'
}

// Locales utilized by the API. Send these with API requests
export enum APILocales {
  RU = 'RU',
  UA = 'UK'
}

const getLocaleFromAttr = (attr: FetchAttr) => {
  const locale = attr?.locale?.toUpperCase();
  if (locale === Locales.UA.toUpperCase()) {
    return APILocales.UA.toUpperCase();
  }
  return locale;
};

export const getAPILocale = (attr?: FetchAttr): string => {
  if (attr?.locale) {
    return getLocaleFromAttr(attr);
  }
  if (
    isClientSide &&
    window?.location?.pathname &&
    window?.location?.pathname.startsWith(`/${Locales.RU.toLowerCase()}`)
  ) {
    return APILocales.RU.toUpperCase();
  }
  return APILocales.UA.toUpperCase();
};
